'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _range3 = require('lodash/range');

var _range4 = _interopRequireDefault(_range3);

var _find3 = require('lodash/find');

var _find4 = _interopRequireDefault(_find3);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _projects = require('redux/modules/projects');

var projectsActions = _interopRequireWildcard(_projects);

var _auth = require('redux/modules/auth');

var _reduxConnect = require('redux-connect');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _strings = require('helpers/strings');

var _projects2 = require('selectors/projects');

var _reactRouter = require('react-router');

var _uploads = require('helpers/uploads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _permissions = require('helpers/permissions');

var _projects3 = require('helpers/projects');

var _auth2 = require('selectors/auth');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRouterRedux = require('react-router-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _SharespacePublishButton = require('containers/Project/SharespacePublishButton/SharespacePublishButton');

var _SharespacePublishButton2 = _interopRequireDefault(_SharespacePublishButton);

var _ProjectLegendLine = require('components/ProjectLegendLine/ProjectLegendLine');

var _ProjectLegendLine2 = _interopRequireDefault(_ProjectLegendLine);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var boxsetsNumbers = (0, _range4.default)(1, 11);
var styles = require('./ProjectMaterials.scss');

var ProjectMaterials = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        projectId = _ref.params.projectId;
    var isLoadProjectTime = projectActions.isLoadProjectTime,
        loadProject = projectActions.loadProject,
        initProject = projectActions.initProject,
        initSubmittedFiles = projectActions.initSubmittedFiles,
        loadMediaList = projectActions.loadMediaList,
        loadPressList = projectActions.loadPressList;

    var id = Number(projectId);
    var promises = [];
    if (id) {
      if (isLoadProjectTime(id, getState())) {
        promises.push(dispatch(loadProject(id)).promise);
      }
    } else {
      promises.push(dispatch(initProject()));
    }
    promises.push(dispatch(initSubmittedFiles()));
    promises.push(dispatch(loadPressList(id)).promise);
    promises.push(dispatch(loadMediaList(id)).promise);

    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    copyProjectLoading: state.project.copyProjectLoading,
    deletePressActionData: state.project.deletePressActionData,
    deletePressLoading: state.project.deletePressLoading,
    mediaList: state.project.mediaListData,
    permissions: (0, _auth2.getPermissions)(state),
    pressList: state.project.pressListData,
    pressListLoading: state.project.pressListLoading,
    project: (0, _projects2.getProjectData)(state),
    projectId: Number(ownProps.params.projectId),
    projectLoading: state.project.projectLoading,
    projectType: ownProps.params.type,
    submittedCloudFiles: state.project.submittedCloudFiles,
    submittedMediaFiles: state.project.submittedMediaFiles,
    submittedPressFiles: state.project.submittedPressFiles
  };
}, (0, _extends3.default)({}, projectActions, { logout: _auth.logout, needReloadProjects: projectsActions.needReloadProjects, pushState: _reactRouterRedux.push })), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectMaterials, _Component);

  function ProjectMaterials() {
    var _ref2;

    (0, _classCallCheck3.default)(this, ProjectMaterials);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProjectMaterials.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials)).call.apply(_ref2, [this].concat(args)));

    _this._mediaUploaderOnSubmitted = function (id) {
      _this.props.submitMediaFile(id);
    };

    _this._mediaUploaderOnComplete = function (id, name, resp) {
      var code = resp.code,
          msg = resp.msg;
      var _this$props = _this.props,
          submittedMediaFiles = _this$props.submittedMediaFiles,
          addMedia = _this$props.addMedia,
          projectId = _this$props.projectId;

      if (code === 1) {
        return _this.props.logout();
      }
      if (code && msg) {
        _toastr2.default.error(msg);
      }
      var data = (0, _get7.default)(resp, 'data[0]');
      if (data) {
        addMedia((0, _extends3.default)({}, data, { uploaderId: id }), projectId);
      }

      console.log(submittedMediaFiles);
      console.log('onComplete', id, name, resp);
    };

    _this._mediaUploaderOnAllComplete = function (succeeded, fail) {
      console.log('onAllComplete', succeeded, fail);
    };

    _this._pressUploaderOnSubmitted = function (id) {
      _this.props.submitPressFile(id);
    };

    _this._pressUploaderOnComplete = function (id, name, resp) {
      var code = resp.code,
          msg = resp.msg;
      var _this$props2 = _this.props,
          addPress = _this$props2.addPress,
          projectId = _this$props2.projectId;

      if (code === 1) {
        return _this.props.logout();
      }

      if (code && msg) {
        _toastr2.default.error(msg);
      }

      var data = (0, _get7.default)(resp, 'data');
      if (data) {
        addPress(data, projectId);
      }
    };

    _this._pressUploaderOnAllComplete = function (succeeded, fail) {
      console.log('onAllComplete', succeeded, fail);
    };

    _this._mountUploaders = function () {
      var FineUploaderTraditional = require('components/FineUploader/traditional');
      var _this$props3 = _this.props,
          projectId = _this$props3.projectId,
          projectType = _this$props3.projectType;

      var postParams = { projectId: projectId, projectType: projectType };

      _this.uploaders.media = new FineUploaderTraditional({
        request: { params: (0, _extends3.default)({}, postParams, { replacedId: 0, part: _this.state.part }) },
        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadAudioVideo' } }
      });

      _this.uploaders.press = new FineUploaderTraditional({
        request: { params: (0, _extends3.default)({}, postParams) },
        chunking: { success: { endpoint: '/api/FileUpload_wa/uploadPress' } }
      });

      _this._registerUploadersEvents();
    };

    _this._unMountUploaders = function () {
      _this._unRegisterUploadersEvents();
      (0, _entries2.default)(_this.uploaders).map(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            name = _ref4[0],
            uploader = _ref4[1];

        uploader.methods.cancelAll();
        _this.uploaders[name] = null;
      });
    };

    _this.state = { part: 1 };
    _this.uploaders = { media: null, press: null };
    return _this;
  }

  (0, _createClass3.default)(ProjectMaterials, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get5.default)(ProjectMaterials.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials.prototype), 'componentDidMount', this).call(this, this._mountUploaders);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _get5.default)(ProjectMaterials.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectMaterials.prototype), 'componentWillUnmount', this).call(this, this._unMountUploaders);
    }
  }, {
    key: 'onCloudUpload',
    value: function onCloudUpload(cloudFile) {
      var _props = this.props,
          addMedia = _props.addMedia,
          projectId = _props.projectId;

      if (cloudFile) {
        addMedia(cloudFile, projectId);
      }
    }
  }, {
    key: 'getRenderProps',
    value: function getRenderProps() {
      var _props2 = this.props,
          t = _props2.t,
          projectType = _props2.projectType,
          permissions = _props2.permissions;

      var props = {};

      props.project = this.props.project || {};
      props.mediaSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)(projectType);
      props.pressSupportedFormats = (0, _uploads.getUploaderAcceptableFormats)('press');
      props.isLocked = !!props.project.isLocked;
      props.isStandardMode = !!props.project.isStandardMode;
      props.canCopy = (0, _permissions.canCreateProjectByType)(permissions, projectType);
      props.showUploadMediaSection = !props.isLocked && !props.isStandardMode;
      props.mediaUploadDisabled = !(0, _permissions.canUploadMedia)(permissions, projectType);
      props.mediaEditDisabled = !(0, _permissions.canEditMedia)(permissions, projectType);
      props.isSharespace = projectType === _projects3.projectTypes.sharespace;
      props.isAudioProject = projectType === _projects3.projectTypes.audio;
      props.isVideoProject = projectType === _projects3.projectTypes.video;
      props.copyButtonTitle = props.isSharespace ? t('Copy this sharespace') : t('Copy this project');
      props.modifyButtonTitle = props.isSharespace ? t('Modify sharespace info') : t('Modify project info');
      props.isWatermarked = props.isVideoProject ? !!props.project.isWatermarkVideo : !!props.project.watermarkTracks;
      props.watermarkWarnText = props.isWatermarked ? t('All tracks will be watermarked') : t('No watermark will be applied');
      props.fileManagementTitle = props.isAudioProject ? t('Audio File Management') : t('File Management');

      return props;
    }
  }, {
    key: '_registerUploadersEvents',
    value: function _registerUploadersEvents() {
      var _this2 = this;

      (0, _entries2.default)(this.uploaders).map(function (_ref5) {
        var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
            name = _ref6[0],
            uploader = _ref6[1];

        uploader.on('submitted', _this2['_' + name + 'UploaderOnSubmitted']);
        uploader.on('complete', _this2['_' + name + 'UploaderOnComplete']);
        uploader.on('allComplete', _this2['_' + name + 'UploaderOnAllComplete']);
      });
    }
  }, {
    key: '_unRegisterUploadersEvents',
    value: function _unRegisterUploadersEvents() {
      var _this3 = this;

      (0, _entries2.default)(this.uploaders).map(function (_ref7) {
        var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
            name = _ref8[0],
            uploader = _ref8[1];

        uploader.off('submitted', _this3['_' + name + 'UploaderOnSubmitted']);
        uploader.off('complete', _this3['_' + name + 'UploaderOnComplete']);
        uploader.off('allComplete', _this3['_' + name + 'UploaderOnAllComplete']);
      });
    }
  }, {
    key: 'copyProject',
    value: function copyProject() {
      var _props3 = this.props,
          project = _props3.project,
          copyProject = _props3.copyProject,
          needReloadProjects = _props3.needReloadProjects,
          t = _props3.t,
          pushState = _props3.pushState;

      copyProject(project.id).promise.then(function () {
        needReloadProjects();
        _toastr2.default.success(t('Project copied'));
        pushState('/projects');
      });
    }
  }, {
    key: 'deletePress',
    value: function deletePress(press) {
      var _props4 = this.props,
          deletePress = _props4.deletePress,
          projectId = _props4.projectId,
          t = _props4.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deletePress(projectId, press.pressId);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this file?'), toastrConfirmOptions);
    }
  }, {
    key: '_setMultipleBoxsets',
    value: function _setMultipleBoxsets(val) {
      var _props5 = this.props,
          setMultipleBoxsets = _props5.setMultipleBoxsets,
          projectId = _props5.projectId;

      setMultipleBoxsets(projectId, val ? 1 : 0);
    }
  }, {
    key: '_changePart',
    value: function _changePart(part) {
      var newPart = Number(part) || 0;
      var mediaUploader = this.uploaders.media;
      this.setState({ part: newPart });
      mediaUploader.methods.setParams((0, _extends3.default)({}, mediaUploader.options.request.params, { part: newPart }));
    }
  }, {
    key: 'deleteMediaItem',
    value: function deleteMediaItem(uploaderId) {
      var _props6 = this.props,
          projectId = _props6.projectId,
          mediaList = _props6.mediaList;

      var media = (0, _find4.default)(mediaList, { uploaderId: uploaderId });
      if (media) {
        return this.props.deleteMedia(projectId, media.id, uploaderId).promise;
      }
    }
  }, {
    key: 'cancelMediaFile',
    value: function cancelMediaFile(id) {
      this.props.deleteMediaFile(id);
    }
  }, {
    key: 'cancelPressFile',
    value: function cancelPressFile(id) {
      this.props.deletePressFile(id);
    }
  }, {
    key: 'uploadButtons',
    value: function uploadButtons() {
      var _props7 = this.props,
          projectId = _props7.projectId,
          projectType = _props7.projectType,
          permissions = _props7.permissions;
      var part = this.state.part;

      var mediaUploadDisabled = !(0, _permissions.canUploadMedia)(permissions, projectType);
      var supportedFileTypes = _config2.default.app.uploaderSupportedFormats.audio;

      return _react2.default.createElement(_components.CloudUploader, {
        disabled: mediaUploadDisabled,
        projectId: projectId,
        onCloudUpload: this.onCloudUpload,
        part: part,
        fileTypes: supportedFileTypes
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props8 = this.props,
          t = _props8.t,
          projectId = _props8.projectId,
          projectType = _props8.projectType,
          projectLoading = _props8.projectLoading,
          copyProjectLoading = _props8.copyProjectLoading,
          submittedMediaFiles = _props8.submittedMediaFiles,
          submittedPressFiles = _props8.submittedPressFiles,
          pressList = _props8.pressList,
          pressListLoading = _props8.pressListLoading,
          deletePressLoading = _props8.deletePressLoading,
          deletePressActionData = _props8.deletePressActionData,
          submittedCloudFiles = _props8.submittedCloudFiles,
          permissions = _props8.permissions;
      var uploaders = this.uploaders,
          _state = this.state,
          isMounted = _state.isMounted,
          part = _state.part;

      var _getRenderProps = this.getRenderProps(),
          project = _getRenderProps.project,
          mediaSupportedFormats = _getRenderProps.mediaSupportedFormats,
          pressSupportedFormats = _getRenderProps.pressSupportedFormats,
          isLocked = _getRenderProps.isLocked,
          isStandardMode = _getRenderProps.isStandardMode,
          canCopy = _getRenderProps.canCopy,
          showUploadMediaSection = _getRenderProps.showUploadMediaSection,
          mediaUploadDisabled = _getRenderProps.mediaUploadDisabled,
          mediaEditDisabled = _getRenderProps.mediaEditDisabled,
          copyButtonTitle = _getRenderProps.copyButtonTitle,
          modifyButtonTitle = _getRenderProps.modifyButtonTitle,
          watermarkWarnText = _getRenderProps.watermarkWarnText,
          fileManagementTitle = _getRenderProps.fileManagementTitle;

      return _react2.default.createElement(
        'div',
        { className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h1',
            null,
            t('Audio & Press Material'),
            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
          ),
          _react2.default.createElement(_components.ProjectBreadcrumbs, { projectId: projectId, projectType: projectType }),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Project')
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-md-60 col-lg-35' },
                _react2.default.createElement(
                  'h4',
                  null,
                  project.artistName
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  project.fullTitle
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'row' },
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-60 col-sm-30' },
                    _react2.default.createElement(
                      'div',
                      null,
                      t('Project Id'),
                      ': ',
                      project.id
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      t('Manager'),
                      ': ',
                      project.ownerName,
                      ' ',
                      project.ownerSurname
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'col-xs-60 col-sm-30' },
                    _react2.default.createElement(
                      'div',
                      null,
                      t('Status'),
                      ': ',
                      _react2.default.createElement(_components.ProjectStatus, { status: project.status })
                    ),
                    project.expiryDate && _react2.default.createElement(
                      'div',
                      null,
                      t('Expiry date'),
                      ': ',
                      project.expiryDateText
                    )
                  )
                )
              ),
              !projectLoading && _react2.default.createElement(
                'div',
                { className: 'col-md-60 col-lg-25 ' + styles.panel },
                _react2.default.createElement(
                  'div',
                  { className: 'padding-15' },
                  _react2.default.createElement(
                    'div',
                    { className: styles.title },
                    t('Security')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.content },
                    _react2.default.createElement(
                      'div',
                      null,
                      watermarkWarnText,
                      '.'
                    ),
                    !!project.multipleIP && _react2.default.createElement(
                      'div',
                      null,
                      t('Recipients can access content from multiple IP addresses'),
                      '.'
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      project.downloadAuthorised ? t('Selected recipients can download files') : t('Selected recipients can\'t download files'),
                      '.'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'margin-vert-20 text-right' },
            copyProjectLoading && _react2.default.createElement(_components.Loader, null),
            canCopy && _react2.default.createElement(
              'button',
              { onClick: this.copyProject, type: 'button', className: 'btn btn-default margin-right-10 margin-vert-5' },
              copyButtonTitle
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'btn btn-primary margin-vert-5', to: '/projects/' + projectType + '/' + projectId + '/info' },
              modifyButtonTitle
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              fileManagementTitle
            ),
            _react2.default.createElement(_components.MediaList, {
              projectId: projectId,
              projectType: projectType,
              multipleBoxsets: !!project.multipleBoxsets,
              isStandardMode: isStandardMode,
              isLocked: isLocked || mediaEditDisabled,
              hideReplaceFile: !permissions.uploadPrContent
            }),
            isMounted && showUploadMediaSection && _react2.default.createElement(
              'div',
              null,
              project.id && _react2.default.createElement(
                'div',
                { className: 'margin-bottom-10' },
                _react2.default.createElement(_components.Checkbox, {
                  name: 'multipleBoxsets',
                  disabled: mediaUploadDisabled,
                  checked: !!project.multipleBoxsets,
                  onChange: function onChange(e) {
                    return _this4._setMultipleBoxsets(e.target.checked);
                  },
                  textAfter: t('Multiple boxsets')
                }),
                !!project.multipleBoxsets && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: (0, _classnames2.default)({ disabled: mediaUploadDisabled }) },
                    t('Upload files for part'),
                    ':'
                  ),
                  _react2.default.createElement(
                    'select',
                    {
                      disabled: mediaUploadDisabled,
                      className: 'margin-left-5',
                      value: part,
                      onChange: function onChange(e) {
                        return _this4._changePart(e.target.value);
                      }
                    },
                    boxsetsNumbers.map(function (partN) {
                      return _react2.default.createElement(
                        'option',
                        { key: partN, value: partN },
                        partN
                      );
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _components.UploadArea,
                {
                  uploader: uploaders.media,
                  disabled: mediaUploadDisabled,
                  uploadButtons: this.uploadButtons(),
                  submittedFiles: submittedMediaFiles,
                  submittedCloudFiles: submittedCloudFiles,
                  accept: mediaSupportedFormats,
                  onDelete: this.deleteMediaItem,
                  onCancel: this.cancelMediaFile,
                  showStatusIcon: true
                },
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  _react2.default.createElement(
                    'div',
                    null,
                    t('Supported file formats: {{formats}}', { formats: mediaSupportedFormats })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    t('TIP - You can upload multiple files at once by pressing "CTRL" key while selecting your files')
                  )
                )
              )
            ),
            !showUploadMediaSection && _react2.default.createElement(
              'div',
              { className: 'bold' },
              t('You don\'t have permissions to manage files')
            )
          ),
          projectType === _projects3.projectTypes.sharespace && _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Cover picture')
            ),
            _react2.default.createElement(_components.ProjectCover, { project: project, disabled: !permissions.uploadSharespaceCover }),
            project.imageThumb && permissions.uploadSharespaceCover && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                null,
                t('Choose the packshot style')
              ),
              _react2.default.createElement(_components.CoverStyle, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Press pack')
            ),
            _react2.default.createElement(
              _components.List,
              { className: 'margin-bottom-20' },
              _react2.default.createElement(
                _components.ListItem,
                { fullWidth: true, isTitle: true },
                _react2.default.createElement(
                  'div',
                  null,
                  t('File Name')
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  t('Uploader')
                ),
                _react2.default.createElement('div', null)
              ),
              pressList.map(function (press) {
                return _react2.default.createElement(
                  _components.ListItem,
                  { fullWidth: true, key: press.pressId },
                  _react2.default.createElement(
                    'div',
                    null,
                    press.fileName
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    (0, _strings.concat)(' ', press.name, press.surname)
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'moreCell' },
                    _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                        return _this4.pressListPopover.toggle(e, press);
                      } }),
                    deletePressLoading && deletePressActionData.pressId === press.pressId && _react2.default.createElement(_components.Loader, { small: true, mask: true })
                  )
                );
              })
            ),
            pressListLoading && _react2.default.createElement(_components.Loader, null),
            _react2.default.createElement(
              _components.PopoverMenu,
              { id: 'pressListPopover', ref: function ref(el) {
                  return _this4.pressListPopover = el;
                } },
              _react2.default.createElement(
                'li',
                { onClick: function onClick() {
                    return _this4.deletePress(_this4.pressListPopover.data);
                  } },
                t('Delete'),
                _react2.default.createElement('i', { className: 'icon-delete' })
              )
            ),
            isMounted && !isStandardMode && _react2.default.createElement(
              _components.UploadArea,
              {
                uploader: uploaders.press,
                submittedFiles: submittedPressFiles,
                accept: pressSupportedFormats,
                onCancel: this.cancelPressFile,
                showStatusIcon: true
              },
              _react2.default.createElement(
                'div',
                { className: 'hint small' },
                _react2.default.createElement(
                  'div',
                  null,
                  t('Upload and shared files of the press pack. Files can be of the following formats:')
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  t('{{formats}}. Max size limit: 7 MB', { formats: pressSupportedFormats })
                )
              )
            ),
            isStandardMode && _react2.default.createElement(
              'div',
              { className: 'bold' },
              t('You don\'t have permissions to manage press pack files')
            )
          ),
          projectType === _projects3.projectTypes.sharespace && _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'div',
              { className: styles.projectsHeader },
              _react2.default.createElement(
                'h3',
                null,
                t('Projects')
              ),
              _react2.default.createElement(_ProjectLegendLine2.default, { hideWatermark: true })
            ),
            _react2.default.createElement(_components.SSProjectsList, { projectId: projectId }),
            _react2.default.createElement(
              'div',
              { className: 'text-right' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'btn btn-primary', to: '/projects/' + projectType + '/' + projectId + '/create' },
                t('Create project')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right margin-vert-40' },
            projectType === _projects3.projectTypes.sharespace ? _react2.default.createElement(_SharespacePublishButton2.default, { project: project }) : _react2.default.createElement(
              _reactRouter.Link,
              {
                className: 'btn btn-primary wide',
                to: '/projects/' + projectType + '/' + projectId + '/' + (projectType === _projects3.projectTypes.sharespace ? 'confirmation' : 'recipients')
              },
              t('Next')
            )
          )
        )
      );
    }
  }]);
  return ProjectMaterials;
}(_ClientSideComponent2.default), _class3.propTypes = {
  addMedia: _propTypes2.default.func,
  addPress: _propTypes2.default.func,
  copyProject: _propTypes2.default.func,
  copyProjectLoading: _propTypes2.default.bool,
  deleteMedia: _propTypes2.default.func,
  deleteMediaFile: _propTypes2.default.func,
  deletePress: _propTypes2.default.func,
  deletePressActionData: _propTypes2.default.object,
  deletePressFile: _propTypes2.default.func,
  deletePressLoading: _propTypes2.default.bool,
  logout: _propTypes2.default.func,
  mediaList: _propTypes2.default.array,
  needReloadProjects: _propTypes2.default.func,
  permissions: _propTypes2.default.object,
  pressList: _propTypes2.default.array,
  pressListLoading: _propTypes2.default.bool,
  project: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  projectLoading: _propTypes2.default.bool,
  projectType: _propTypes2.default.string,
  pushState: _propTypes2.default.func,
  setMultipleBoxsets: _propTypes2.default.func,
  submitMediaFile: _propTypes2.default.func,
  submitPressFile: _propTypes2.default.func,
  submittedCloudFiles: _propTypes2.default.array,
  submittedMediaFiles: _propTypes2.default.array,
  submittedPressFiles: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onCloudUpload', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onCloudUpload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'copyProject', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'copyProject'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteMediaItem', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteMediaItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelMediaFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancelMediaFile'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelPressFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancelPressFile'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ProjectMaterials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectMaterials/ProjectMaterials.js
// module id = 2196
// module chunks = 1